export default "__VITE_ASSET__5qWsTqC0__"